import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { fromJS as ImmutableFromJs } from 'immutable';
import AutoScopeStyles from '../../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../../../../../Common/Utilities/Decorators/ApplyDecorators';

class InputElementWithLabel extends React.PureComponent {
    constructor() {
        super();
        this.id = shortid.generate();
    }

    render() {
        return (
            <div>
                <input autoFocus={ this.props.autoFocus }
                       value={ this.props.value }
                       type={ this.props.inputElementName }
                       id={ this.id }
                       checked={ this.props.isChecked }
                       onChange={ this.onChange }/>
                <label htmlFor={ this.id }>{ this.props.label }</label>
            </div>
        );
    }

    onChange = event => {
       const isSelected = event.target.checked ? true : false;
       this.props.onChange(ImmutableFromJs({id: this.props.value, name: this.props.label}), isSelected);
    }

    static propTypes = {
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        isChecked: PropTypes.bool.isRequired,
        inputElementName: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired //onChange(newValue: Immutable<{id, name}>, isSelected: bool)
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(InputElementWithLabel);
